import * as types from './types'
import keywordApi from '../api'

export const actions = {
    async [types.KEYWORD_FETCH]({commit}, data = null) {
        commit(types.KEYWORD_SET_LOADING, true)
        const response = await keywordApi.all(data)
        commit(types.KEYWORD_OBTAIN, response.data.data)
        commit(types.KEYWORD_META, response.data.meta)
        commit(types.KEYWORD_SET_LOADING, false)
    },
}
